import { useQueryParam } from '@atlassian/jira-router';

export const useConfigQuery = (): [string, (param: string) => void] => {
	const [configQuery, setConfigParam] = useQueryParam('config');

	if (!configQuery) {
		throw new Error('No config param found');
	}

	return [configQuery, setConfigParam];
};
